import * as React from 'react';
import Modal from './Modal';
import Select, { components } from 'react-select';
import Button from './Button';
import Common from '../util/common';
import styled from 'styled-components';
const settings = require('../settings.json');
const allPlayers = require('../allPlayers.json');
class PlayerSearchModal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            restrictByPosition: true,
            sortType: "_fantasyPoints"
        };
        this.players = [];
        this.selectPlayerHandler = (data) => {
            console.log(data);
            this.players = [];
            data.forEach((player) => {
                this.players.push(Object.assign({}, player.player));
            });
        };
        this.sortPlayers = (data) => {
            console.log("sortPlayers", data);
            this.setState({ sortType: data.value });
        };
        this.addPlayerHandler = () => {
            this.props.handlers.addPlayer([...this.players]);
        };
        this.cancelPlayerModalHandler = () => {
            this.props.handlers.cancelPlayerModal();
        };
        this.restrictByPositionHandler = (willRestrict) => {
            this.setState({ restrictByPosition: willRestrict });
        };
        this.hasPlayerStats = (player) => {
            return player['stats']
                && (typeof player.stats === 'object' || typeof player.stats === 'object');
        };
        this.playerStats = (player) => {
            if (this.hasPlayerStats(player)) {
                return player.stats;
            }
            return undefined;
        };
        this.sortOptions = () => {
            return [
                {
                    value: "_fantasyPoints",
                    label: "Fantasy Points"
                },
                {
                    value: "_fantasyPointsAverage",
                    label: "Fantasy Points Average"
                },
                {
                    value: "points",
                    label: "Points"
                },
                {
                    value: "goals",
                    label: "Goals"
                },
                {
                    value: "assists",
                    label: "Assists"
                },
                {
                    value: "penaltyMinutes",
                    label: "Penalty Minutes"
                },
                {
                    value: "plusMinus",
                    label: "Plus/Minus"
                },
                {
                    value: "hits",
                    label: "Hits"
                },
                {
                    value: "powerPlayGoals",
                    label: "Power Play Goals"
                },
                {
                    value: "powerPlayPoints",
                    label: "Power Play Points"
                },
                {
                    value: "shots",
                    label: "Shots"
                },
                {
                    value: "blocked",
                    label: "Blocks"
                }
            ];
        };
    }
    render() {
        console.log("render modal");
        const common = new Common();
        let players = allPlayers
            .map((player) => {
            return {
                value: player.id,
                label: player.fullName,
                player: Object.assign({}, player)
            };
        })
            .sort((a, b) => {
            let statA = 0;
            let statB = 0;
            if (a.player.stats && a.player.stats[this.state.sortType]) {
                if (typeof a.player.stats[this.state.sortType] === 'string') {
                    statA = parseFloat(a.player.stats[this.state.sortType]);
                }
                else {
                    statA = a.player.stats[this.state.sortType];
                }
            }
            if (b.player.stats && b.player.stats[this.state.sortType]) {
                if (typeof b.player.stats[this.state.sortType] === 'string') {
                    statB = parseFloat(b.player.stats[this.state.sortType]);
                }
                else {
                    statB = b.player.stats[this.state.sortType];
                }
            }
            return (statB - statA);
        });
        if (this.state.restrictByPosition) {
            players = players.filter((player) => {
                return player.player.position === this.props.playerPosition;
            });
        }
        const SelectPlayerOption = (props) => {
            let statValue = 0;
            if (this.playerStats(props.data.player)) {
                statValue = props.data.player.stats[this.state.sortType];
            }
            return (React.createElement("div", null,
                React.createElement(components.Option, Object.assign({}, props),
                    React.createElement(FanPts, null, statValue),
                    " ",
                    React.createElement("span", null, props.label))));
        };
        const title = "Add Players (" + settings.positionMap[this.props.playerPosition].label + ")";
        const buttons = (React.createElement(React.Fragment, null,
            React.createElement(Button, { label: "Add", clicked: this.addPlayerHandler }),
            React.createElement(Button, { label: "Cancel", clicked: this.cancelPlayerModalHandler })));
        const handlers = {
            closeModal: this.props.handlers.closePlayerModal
        };
        return (React.createElement(Modal, { show: true, title: title, buttons: buttons, handlers: handlers },
            React.createElement(ModalStyle, null,
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("label", { htmlFor: "restrictByPosition" },
                                    "Show Only ",
                                    settings.positionMap[this.props.playerPosition].label)),
                            React.createElement("td", null,
                                React.createElement("input", { id: "restrictByPosition", type: "checkbox", checked: this.state.restrictByPosition, onChange: (event) => { this.restrictByPositionHandler(event.target.checked); } }))),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Sort By"),
                            React.createElement("td", null,
                                React.createElement(Select, { onChange: this.sortPlayers, defaultValue: this.sortOptions()[0], styles: common.selectStyles(), isMulti: false, options: this.sortOptions() }))))),
                React.createElement(Select, { onChange: this.selectPlayerHandler, placeholder: "Select Players...", styles: common.selectStyles(), isMulti: true, closeMenuOnSelect: false, components: { Option: SelectPlayerOption }, options: players }))));
    }
}
;
export default PlayerSearchModal;
const ModalStyle = styled.div `
  table {
    margin-bottom: 20px;
    width: 100%;
  }

  table td:first-child {
    width: 200px;
  }
`;
const FanPts = styled.span `
  background-color: #3b5a89;
  border-radius: 5px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  text-align: center;
  width: 45px;
  padding: 5px;
`;
//# sourceMappingURL=PlayerSearchModal.js.map


// WEBPACK FOOTER //
// ./src/components/PlayerSearchModal.js